exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    background-color: #4eafe4;\r\n    height: 60px;\r\n    padding-left: 20px;\r\n    align-items: center;\r\n    flex-grow: 0;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.title {\r\n    font-size: 28px;\r\n    color: #fff;\r\n    font-weight: bold;\r\n}\r\n\r\n.panel-buttons {\r\n    margin-left: auto;\r\n    display: flex;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/pages/page-header-bar.component.css
// module id = 2150
// module chunks = 1